import { render, staticRenderFns } from "./ot-claim-recommendation-overrule-dialog.vue?vue&type=template&id=0dbaf34e&scoped=true&"
import script from "./ot-claim-recommendation-overrule-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-recommendation-overrule-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-recommendation-overrule-dialog.vue?vue&type=style&index=0&id=0dbaf34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbaf34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
